import React from "react";

export default function Card({ logo, title, desc, link, img }) {
  return (
    <div className="card">
      <div className="card-text">
        {logo && (
          <div className="card-logo-wrapper">
            <img src={logo} alt={title} className="card-logo" />
          </div>
        )}
        <h3>{title}</h3>
        <p>{desc}</p>
        <a href={link} target="_blank" rel="noreferrer" className="visit-link">
          Visit site <span className="arrow">→</span>
        </a>
      </div>
      {img && (
        <div className="card-image-wrapper">
          <img src={img} alt={title} className="card-image" />
        </div>
      )}
    </div>
  );
}
